import { of as observableOf, Observable } from "rxjs";
import { CanActivate } from "@angular/router";
import { KpiService } from "./kpi/kpi.service";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";
import { map } from "rxjs/operators";

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private kpiService: KpiService) {}

  canActivate(): Observable<boolean> | boolean {
    return this.kpiService.getUserInfo().pipe(
      map((response) => {
        return response ? true : false;
      })
    );
  }
}
